import React from "react";
import "./Footer.css";
import pinIcon from "../asset/icons/pin.svg";
import mailIcon from "../asset/icons/mail-icon.svg";
import arrowIcon from "../asset/icons/arrow-icon.svg";
import Modal from "./Modal";
import { useState } from "react";

const Footer = () => {
  const scrollToTop = () => {
    const startY = window.scrollY;
    const endY = 0;
    const duration = 1200; // ms
    const startTime = performance.now();
    function scrollStep(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // easeOutCubic: fast start, slow finish
      const ease = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, startY + (endY - startY) * ease);
      if (progress < 1) {
        requestAnimationFrame(scrollStep);
      }
    }
    scrollStep(performance.now());
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [privacyContent, setPrivacyContent] = useState("");
  const handlePrivacyClick = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/privacy-policy.html");
      const html = await res.text();
      // Extract only the <body> content for cleaner modal
      const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
      setPrivacyContent(match ? match[1] : html);
      setModalOpen(true);
    } catch {
      setPrivacyContent("<p>Errore nel caricamento della Privacy Policy.</p>");
      setModalOpen(true);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-branding">
              <h2 className="footer-title">Sara Bocca</h2>
              <div className="footer-subtitle">
                <p className="footer-subtitle-text">
                  RESTAURATRICE DI BENI CULTURALI
                </p>
                <p className="footer-subtitle-text">
                  • PITTORICO • LIGNEO • LAPIDEO •
                </p>
              </div>
              <p className="footer-text">P.IVA 02980050187</p>
            </div>

            <div className="footer-contact">
              <div className="footer-contact-item">
                <img src={pinIcon} alt="Location" className="footer-icon" />
                <p className="footer-contact-text">Vigevano (PV)</p>
              </div>

              <div className="footer-contact-item">
                <svg
                  className="footer-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.85494 14.145C11.0749 15.3649 12.5248 16.3347 14.1147 16.9699C14.3144 17.0497 14.5379 16.9939 14.6802 16.8516L16.5232 15.0086C16.6628 14.869 16.8637 14.8133 17.0524 14.8594L21.208 15.9341C21.4405 15.9926 21.6 16.2058 21.6 16.4453V20.4C21.6 20.7314 21.3313 21 21 21C15.4772 21 10.8 18.9 7.2 15.3C3.6 11.7 1.5 7.02275 1.5 1.5C1.5 1.16863 1.76863 0.9 2.1 0.9H6.05467C6.29416 0.9 6.50744 1.05955 6.56592 1.29203L7.64059 5.44758C7.68665 5.63628 7.631 5.83721 7.49136 5.97682L5.64843 7.81976C5.50608 7.96211 5.4503 8.18562 5.53012 8.3853C6.16528 9.97524 7.13509 11.4251 8.35494 12.645L9.85494 14.145Z"
                    stroke="#6B6B6B"
                    strokeWidth="2"
                  />
                </svg>
                <a className="footer-contact-text" href="tel:+393478609792">
                  +39 347 8609792
                </a>
              </div>

              <div className="footer-contact-item">
                <img src={mailIcon} alt="" className="footer-icon" />
                <a
                  className="footer-contact-txt links"
                  href="mailto:sarabocca.restauri@gmail.com"
                >
                  sarabocca.restauri@gmail.com
                </a>
              </div>
              <div style={{ height: 12 }}></div>
              <div className="footer-contact-item">
                <a
                  className="footer-designer-text"
                  href="/privacy-policy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handlePrivacyClick}
                >
                  Privacy Policy
                </a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-designer-text">
                  progettato e realizzato da{" "}
                  <a
                    href="https://matteonegri.eu"
                    className="footer-designer-text"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    matteonegri.eu
                  </a>
                </span>
              </div>
            </div>

            <div className="footer-links-container">
              <div className="footer-links">
                <span>
                  <a href="#competenze" className="footer-link">
                    Competenze
                  </a>
                </span>
                <span>
                  <a href="#chi-sono" className="footer-link">
                    Chi sono
                  </a>
                </span>
                <span>
                  <a href="#lavori" className="footer-link">
                    Selezione lavori
                  </a>
                </span>
                <span>
                  <a href="#prima-dopo" className="footer-link">
                    Prima e dopo
                  </a>
                </span>
              </div>

              <button onClick={scrollToTop} className="back-to-top-btn">
                <span>Torna in cima</span>
                <img src={arrowIcon} alt="" className="arrow-up" />
              </button>
            </div>
          </div>

          <div className="footer-divider"></div>

          <p className="copyright-text">
            © 2026 Sara Bocca Restauri. Tutti i diritti riservati.
          </p>
        </div>
      </div>
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <div dangerouslySetInnerHTML={{ __html: privacyContent }} />
      </Modal>
    </footer>
  );
};

export default Footer;
